<template>
  <aside class="sidebar">
    <el-menu
      :default-active="activeMenu"
      class="sidebar-menu"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="item in menuItems"
        :key="item.path"
        :index="item.path"
      >
        <el-icon><component :is="item.icon" /></el-icon>
        <span>{{ item.label }}</span>
      </el-menu-item>
    </el-menu>
    <div class="sidebar__version">V1 试点版 · 0.1.0</div>
  </aside>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import { useNavigationItems } from "@/composables/useNavigationItems";
const route = useRoute();
const router = useRouter();
const activeMenu = computed(() => route.path.startsWith("/issues") ? "/issues" : route.path);
const handleSelect = (path: string) => router.push(path);
const menuItems = useNavigationItems();
</script>
